module.exports = __webpack_public_path__ + "static/img/jscztmb_logo.fa3137d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jscztmb_logo.png
// module id = ekLZ
// module chunks = 1